import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import ComboboxInput from "../Reusable/ComboboxInput";
import DateRangePicker from "../Reusable/DateRange";

export default function Filter(props: any) {
  const { register, errors, setValue, getValues, clearErrors, watch } = props;
  return (
    <div
      className={tw`p-2 rounded-md space-y-4 bg-[#fefefe] mb-2`}
      style={{
        boxShadow: "0px 1px 6px 0px #00000040",
      }}
    >
      <div className={tw`grid grid-cols-3 gap-6`}>
        <ComboboxInput
          url={APIS.USER}
          queryKey={"party"}
          register={register("user")}
          errors={errors?.user}
          name={"user"}
          label={"Party"}
          setValue={setValue}
          getValues={getValues}
          placeholder={"Search... "}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          url={APIS.PRODUCT}
          queryKey={"product"}
          register={register("product")}
          errors={errors?.product}
          name={"product"}
          label={"Product"}
          setValue={setValue}
          props={{
            is_group: false,
          }}
          getValues={getValues}
          placeholder={"Search..."}
          clearErrors={clearErrors}
        />
        <DateRangePicker
          label={"Select Date Range"}
          setValue={setValue}
          name={"created__range"}
          getValues={getValues}
        />
      </div>
    </div>
  );
}

